import { describeError } from '@classgo/app-kit';

import { albertRefusal } from '../../albert/refusals';
import { useT } from '../../i18n';

/**
 * A failed request as the teacher reads it: Albert's refusal in one sentence (never grades, quota
 * spent, personal data, a pair not held) or the generic description, in red, with the retry
 * that reuses what was typed. The form above keeps its values (ui-practices 12 and 13).
 */
export const RefusalNotice = ({
  error,
  onRetry,
  retrying,
}: {
  error: unknown;
  onRetry: () => void;
  retrying: boolean;
}) => {
  const t = useT();
  const key = albertRefusal(error);
  return (
    <div
      role="alert"
      className="flex flex-col gap-2 rounded-card bg-danger-100 px-4 py-3 text-sm text-danger-700 sm:flex-row sm:items-center sm:justify-between"
    >
      <p>
        <span className="font-medium">{t('albert.refusal.title')}: </span>
        {key ? t(key) : describeError(t, error)}
      </p>
      {key === 'albert.refusal.quotaExhausted' ? null : (
        <button
          type="button"
          className="control-touch self-start font-medium underline underline-offset-2 hover:decoration-2 disabled:text-gray-400 sm:self-auto"
          disabled={retrying}
          onClick={onRetry}
        >
          {t('albert.retry')}
        </button>
      )}
    </div>
  );
};
